export class MockDevice{
    constructor(device){
        this.Name = device.Name;
        this.AllowedMessages = device.AllowedMessages;
        this.MessageAttributes = {};
        this.AllowedMessages.forEach(e => this.MessageAttributes[e] = device.messageAttributes(e));
        this.Index = device._index;
    }
}